import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { DashboardEditorProps } from "components/ComponentType";
import { SankeyDiagramProps, SankeyDiagramNode } from "../sankey-types";

type XYPositionsEditorProps = {
  selectedNode: SankeyDiagramNode | null;
} & DashboardEditorProps<SankeyDiagramProps>



const XYPositionsEditor = ({ config, onConfigChange, selectedNode }: XYPositionsEditorProps) => {
  if (!selectedNode) return null;

  const nodeIndex = config.graph.nodes.findIndex(node => node.id === selectedNode.id);

  const handlePositionChange = (field: "x" | "y", value: number) => {
    const updatedPositions = {
      x: config.nodesPosition?.x || [],
      y: config.nodesPosition?.y || [],
    };
    if (updatedPositions[field] !== undefined) {
      updatedPositions[field][nodeIndex] = value;
    }
    onConfigChange({ ...config, nodesPosition: updatedPositions });
  };

  const renderEditor = (field: "x" | "y") => {
    return (
      <InputNumber
        value={config.nodesPosition?.[field][nodeIndex]}
        onValueChange={({ value }) => {
          if (value !== null) {
            handlePositionChange(field, value);
          }
        }}
        className="p-inputtext-sm p-2"
        maxFractionDigits={18}
        onFocus={e => e.target.select()}
      />
    );
  };

  const renderPositionCell = (field: "x" | "y") => {
    return <div>{config.nodesPosition?.[field][nodeIndex]}</div>;
  };

  return (
    <div className="flex flex-column gap-2">
      <DataTable
        value={[selectedNode]}
        editMode="row"
        onRowEditComplete={() => onConfigChange(config)}
        dataKey="id"
      >
        <Column
          field="x"
          header="X"
          body={() => renderPositionCell("x")}
          editor={() => renderEditor("x")}
        />
        <Column
          field="y"
          header="Y"
          body={() => renderPositionCell("y")}
          editor={() => renderEditor("y")}
        />
        <Column rowEditor headerStyle={{ width: "4rem" }} />
      </DataTable>
    </div>
  );
};

export default XYPositionsEditor;
